import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './styles.scss';

const cx = classNames.bind(styles);

class ActionButtonGroup extends PureComponent {
  render() {
    const { className, fullWidth, children, ...props } = this.props;
    return (
      <div
        className={cx('ActionButtonGroup', { fullWidth }, className)}
        {...props}
      >
        {children}
      </div>
    );
  }
}

ActionButtonGroup.propTypes = {};

export default ActionButtonGroup;
